"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.definedSocialClickIds = exports.parseUTMParams = exports.getUserTraits = exports.page = exports.updateUserTraits = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const updateUserTraits = (traits) => {
    if (Object.keys(traits).length === 0) {
        return;
    }
    window.analytics?.identify(traits);
};
exports.updateUserTraits = updateUserTraits;
const page = (properties) => {
    const DELAY_IN_MS = 200;
    window.setTimeout(() => {
        window.analytics?.page(document.title, properties);
    }, DELAY_IN_MS);
};
exports.page = page;
const getUserTraits = () => {
    const user = window.analytics?.user?.();
    const traits = user?.traits?.() || {};
    return {
        context: {
            traits,
        },
    };
};
exports.getUserTraits = getUserTraits;
const parseUTMParams = () => {
    const params = new URLSearchParams(window.location.search);
    const campaign = {};
    for (const [key, value] of params.entries()) {
        if (key.startsWith('utm_')) {
            campaign[key] = value;
        }
    }
    return campaign;
};
exports.parseUTMParams = parseUTMParams;
const definedSocialClickIds = (cookieKeys) => {
    return Object.fromEntries(cookieKeys.map((key) => [key, js_cookie_1.default.get(key)]).filter(([_, value]) => value));
};
exports.definedSocialClickIds = definedSocialClickIds;
